import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.js';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'flex min-h-[80px] w-full rounded-md border border-[var(--app-divider-2)] bg-[var(--n-0)] px-3 py-2 text-body',
      'text-[var(--ink-700)] placeholder:text-[var(--fg-faint)]',
      'focus:outline-none focus-visible:border-[var(--brand-500)] focus-visible:ring-2 focus-visible:ring-[var(--brand-500)]/30',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
